import {
  List
} from 'immutable';

import { METIERSSTEPS_FETCH } from '../constants/ActionTypes';

const initialState = new List();
export default (state = initialState, action) => {
  switch (action.type) {
    case METIERSSTEPS_FETCH: {
      return action.payload;
    }
    default:
      return state;
  }
};
